import React, { useState } from "react";
import { TextField, MenuItem } from "@mui/material";
import { useTranslation } from "react-i18next";

const FilterTemporada = ({ temporadas, onChangeTemporada }) => {
  const { t } = useTranslation("players");
  const [temporadaSeleccionada, setTemporadaSeleccionada] = useState("");
  const seasons = [...new Map((temporadas || []).map(season => [
    String(season.idTemporada ?? season.id), season,
  ])).entries()].sort(([a], [b]) => Number(b) - Number(a));
  return (
    <TextField
      select
      label={t("modern.seasonLabel")}
      value={temporadaSeleccionada}
      onChange={(event) => {
        setTemporadaSeleccionada(event.target.value);
        onChangeTemporada(event.target.value);
      }}
      slotProps={{ select: { displayEmpty: true }, inputLabel: { shrink: true } }}
      fullWidth
    >
      <MenuItem value="">{t("modern.allSeasons")}</MenuItem>
      {seasons.map(([id, season]) => (
        <MenuItem key={id} value={id}>
          {season.nombre || t("modern.season", { season: id })}
        </MenuItem>
      ))}
    </TextField>
  );
};

export default FilterTemporada;
